import { useCallback, useMemo } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { setCarInstance, updateErrors } from 'store/carInstance/actions';
import { VALUE_FIELDS } from 'store/carInstance/constants';
import { selectErrors, selectValues } from 'store/carInstance/selectors';

import { useDisabledFields } from '../../hooks/useDisabledFields';

import { NAME } from './YearSelect.constants';

export const useYearSelectPresenter = () => {
  const dispatch = useDispatch();

  const { [NAME]: error } = useSelector(selectErrors);
  const { [NAME]: value, [VALUE_FIELDS.IS_NEW]: isNew } = useSelector(selectValues);

  const { disabled: pageRestrict } = useDisabledFields();

  const list = useMemo(() => {
    const current = new Date().getFullYear();
    const last = isNew ? current - 3 : 1990;

    let target = current;
    const result = [];

    while (target > last) {
      result.push({ id: target, title: target });
      target--;
    }

    return result;
  }, [isNew]);

  const onChange = useCallback(({ [NAME]: option }) => {
    const { id: value } = option ?? {};

    dispatch(setCarInstance({ [NAME]: value }));
    dispatch(updateErrors({ [NAME]: '' }));
  }, []);

  return { disabled: pageRestrict, error, list, onChange, value };
};
